import React, {useState, useEffect} from 'react';
import { useWeb3 } from '@openzeppelin/network/react';

import { Web3ReactProvider } from '@web3-react/core'
import { Web3Provider } from '@ethersproject/providers'
import { useWeb3React } from '@web3-react/core'
import { InjectedConnector } from '@web3-react/injected-connector'

import {formatEther} from "@ethersproject/units";

import { Contract } from '@ethersproject/contracts'
import { isAddress } from '@ethersproject/address'

import useSWR from 'swr'

import GFCABI from '../abi/GameForCrypto.abi.json'

import { fetcher } from '../util/Fetcher.js';

import { creditWeiCost, smartContractAddress } from '../util/Constants.js';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import theme from '../theme'

import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

export const CreditBalance = (props) => {
    const { account, library } = useWeb3React();
    const { data: creditBalance, mutate } = useSWR([smartContractAddress,'memberAcctBalance'], {
      fetcher: fetcher(library, GFCABI),
    })

    const classes = useStyles();
  
    const [availableCredits, setAvailableCredits] = useState(null);
    const [withdrawlCreditValue, setwithdrawlCreditValue] = useState(1);
  
    const [myContract, setMyContract] = useState(null);
    const [hasInit, setHasInit] = useState(false);
  
    let address = '0x8B86Efbe8E6f0D09511DE1AbC1C0663896acFEa2';
  
    useEffect(() => {
      // listen for changes on an Ethereum address
      console.log(`listening for blocks...`)
      library.on('block', () => {
        console.log('update balance...')
        mutate(undefined, true)
      })
      // remove listener when the component is unmounted
      return () => {
        library.removeAllListeners('block')
      }
      // trigger the effect only on component mount
    }, [])
  
    useEffect(() => {
      if(library && !hasInit){
        const contract = new Contract(smartContractAddress, GFCABI, library.getSigner());
        setMyContract(contract);
        setHasInit(true);
      }
      
    },[library])
  
    useEffect(() => {
  
      if(creditBalance){
      console.log(creditBalance.toNumber());
      setAvailableCredits(creditBalance.toNumber());
      }
  
    },[creditBalance])
  
    const withdrawlCredits = () => {
      console.log('Attempt withdrawlCredits..', account);
  
      if(myContract !== null){
        console.log(myContract);
  
        //myContract.methods.getOwner().call()
        myContract['withdrawlGamerCredits'](withdrawlCreditValue)
        .then(result => {
          console.log(`result`, result);
        })
  
        
      }
    }
  
    const displayWithdrawlCredits = () => {
  
      let display = null;
  
      if(availableCredits > 0){
        display = (
          <div>
          <input type={'text'} value={withdrawlCreditValue} onChange={(event) => {
            setwithdrawlCreditValue(event.target.value);
          }} />
          <button
            onClick={() => {
              if(withdrawlCreditValue <= availableCredits){
                withdrawlCredits();
              }
            }}
            > Withdraw Credits </button>
          </div>
        )
      }
  
      return display;
  
    }
  
    let display = null;
  
    if(creditBalance){
      //display = creditBalance;
    }
  
    if (!availableCredits) {
      return (<div>
      <Typography variant="h6" className={classes.title}>
           No Credits. Insert To Continue.
          </Typography>
      </div>)
    }
    return (
      <Paper elevation={3}>
        <Typography variant="h5" className={classes.title}>
           Credit Balance
          </Typography>
        <p>Credits: {availableCredits}</p>
        {displayWithdrawlCredits()}
      </Paper>
      
    )
  }
  